/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import {WealthyEnv} from "helpers";

const PARTNERS_CDN_URL = WealthyEnv.PARTNERS_CDN_URL;

const srimantaImage = `${PARTNERS_CDN_URL}/partners-srimanta-wm.png`;
const sameerImage = `${PARTNERS_CDN_URL}/partners-sameer-wm.png`;
const varunImage = `${PARTNERS_CDN_URL}/partners-varun-wm.png`;
const birendraImage = `${PARTNERS_CDN_URL}/partners-birendra-wm.png`;
const nirbanImage = `${PARTNERS_CDN_URL}/partners-nirban-wm.png`;



const advisors = [
  {
    id: 1,
    videoLink: `${PARTNERS_CDN_URL}/partners-agent-onboarding-video-varun.mp4`,
    image: varunImage,
    name: "Varun Krishna",
    designation: "Wealth Partner",
    experience: "CFP | Ex-Northern Trust | Ex-International Money Matters"
  },
  {
    id: 2,
    videoLink: `${PARTNERS_CDN_URL}/partners-agent-onboarding-video-birendra.mp4`,
    image: birendraImage,
    name: "Birendra",
    designation: "Wealth Partner",
    experience: "Ex-Branch Manager"
  },
  // {
  //   id: 3,
  //   videoLink: `${PARTNERS_CDN_URL}/partners-agent-onboarding-video-srimanta.mp4`,
  //   image: srimantaImage,
  //   name: "Srimanta Patra",
  //   designation: "Wealth Partner",
  //   experience: "Ex-ICICI Securities"
  // },
  {
    id: 4,
    videoLink: `${PARTNERS_CDN_URL}/partners-agent-onboarding-video-sameer.mp4`,
    image: sameerImage,
    imageStyles: {
      objectPosition: "center 15%"
    },
    name: "Sameer Chhappar",
    designation: "Wealth Partner",
    experience: "Program Manager | Ex-Manipal Technologies"
  },
  {
    id: 5,
    videoLink: `${PARTNERS_CDN_URL}/partners-agent-onboarding-video-nirban.mp4`,
    image: nirbanImage,
    name: "Nirban Nandy",
    designation: "Insurance Advisor",
    experience: "Ex-PNB"
  }
];

export default advisors;
